import { render, staticRenderFns } from "./BenefitRing.vue?vue&type=template&id=2115cc86&scoped=true"
import script from "./BenefitRing.vue?vue&type=script&lang=js"
export * from "./BenefitRing.vue?vue&type=script&lang=js"
import style0 from "./BenefitRing.vue?vue&type=style&index=0&id=2115cc86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2115cc86",
  null
  
)

export default component.exports